import { Button as MuiButton } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { ButtonProps } from './services/buttonInterface';
import CircularProgress from '@mui/material/CircularProgress';

const useStyles = makeStyles({
  iconOnly: {
    '& .MuiButton-startIcon': {
      marginRight: 0,
      marginLeft: 0
    }
  }
});

export const Button = ({ btnText, icon, btnClass, loading, ...props }: ButtonProps) => {
  const classes = useStyles();
  return (
    <MuiButton
      startIcon={icon}
      component="span"
      sx={{
        padding: btnText ? '6px 16px' : '6px'
      }}
      className={btnText ? btnClass : classes.iconOnly}
      disabled={loading || props.disabled}
      {...props}
    >
      {loading ? <CircularProgress size={24} color="inherit" /> : btnText}
    </MuiButton>
  );
};
